import React, { Fragment } from 'react'
import { useState } from 'react'
import { Row, Button, Col, Modal, Container, Card } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import Bitacora from '../../bitacora'
import PretensionesModal from './modalPretensiones'
import { useNavigate } from 'react-router-dom'
import PrevisionesModal from './modalPrevisiones'
import { getCasoImplicado } from '../../../api/api-gestion-defensa'
import {CarpetaDigitalComponent} from 'defcol-caso-general'

const Acciones = ({ implicadoSeleccionado }) => {
  const history = useNavigate()
  const queryState = JSON.parse(localStorage.getItem('filtrosRecuperoDirecto'))


  const [showCarpeta, setShowCarpeta] = useState(false)
  const [showBitacora, setShowBitacora] = useState(false)
  const [showPretensiones, setShowPretensiones] = useState(false)
  const [showPrevisiones, setShowPrevisiones] = useState(false)

  const [showImplicados, setShowImplicados] = useState(false)
  const [showImplicadosHistorial, setShowImplicadosHistorial] = useState(false)

  const [showImplicadosPrev, setShowImplicadosPrev] = useState(false)
  const [showImplicadosHistorialPrev, setShowImplicadosHistorialPrev] = useState(false)
  const [inprocess, setInprocess] = useState(false);
  const [implSeleccionado, setImplSeleccionado] = useState("");

  const data_gestion_defensa = useSelector((state) => state.gestionDefensaReducer)
  const { llaves, cfg_form38 } = data_gestion_defensa

  const [showModalInfo, setShowModalInfo] = useState(false);

  const handleShowBitacora = () => setShowBitacora(true)
  const handleCloseBitacora = () => setShowBitacora(false)
  const handleShowCarpeta = () => setShowCarpeta(true)
  const handleCloseCarpeta = () => setShowCarpeta(false)

  const handleShowPretensiones = () => setShowPretensiones(true)

  const handleClosePretensiones = () => {
    setShowPretensiones(false)
    setShowImplicados(false)
    setShowImplicadosHistorial(false)
  }

  const handleClosePrevisiones = () => {
    setShowPrevisiones(false);
    setShowImplicadosPrev(false);
    setShowImplicadosHistorialPrev(false);
  }

  const handleShowProvisiones = async () => {
    const query = Buffer.from(JSON.stringify({ idCaso: llaves && llaves['idCaso'], idImplicado: implicadoSeleccionado })).toString('base64');
    const response = await getCasoImplicado(query);

    /*if (response && response[0]?.ultimaProvision?.CodMonedaIngreso && response[0]?.ultimaProvision?.CodSituacion === 245002) {
      setInprocess(false);
      setShowPrevisiones(true);
    } else if (response && !response[0]?.ultimaProvision?.CodMonedaIngreso && !response[0]?.ultimaProvision?.CodInstancia) {
      setInprocess(false);
      setShowPrevisiones(true);
    } else {
      setInprocess(true);
      setShowPrevisiones(true);
      setImplSeleccionado(response && response[0] ? response[0] : {});
    }*/
   if (response && response[0]?.ultimaPropuestaIndeminizacion?.CodMonedaIngreso && response[0]?.ultimaPropuestaIndeminizacion?.CodSituacion === 245002) {
        setInprocess(false);
        setShowPrevisiones(true);
    } else if (response && !response[0]?.ultimaPropuestaIndeminizacion?.CodMonedaIngreso && !response[0]?.ultimaPropuestaIndeminizacion?.CodInstancia) {
        setInprocess(false);
        setShowPrevisiones(true);
    } else {
        setInprocess(true);
        setShowPrevisiones(true);
        setImplSeleccionado(response && response[0] ? response[0] : {});
    }
  }


  return (
    <>
      <style type='text/css'>
        {`
    .btn-carpeta {
      background-color: #F0AD3E;
      color: #FFFFFF;
      width: 140px;
      
    }
    .btn-carpeta:hover{
        background-color:#e1b97f;
        color: #FFFFFF;

    }
    .btn-bitacora {
      background-color: #55B2CE;
      color: #FFFFFF;
      width: 140px;
    }
    .btn-bitacora:hover{
        background-color: #87c9dc;
        color: #FFFFFF;
    } 
    .btn-valorizacionpec {
      background-color: #55B2CE;
      color: #FFFFFF;
      width: 150px;
    }
    .btn-valorizacionpec:hover{
        background-color: #87c9dc;
        color: #FFFFFF;
    }    
    .btn-pretensiones {
      background-color: #1fcbd4;
      color: #FFFFFF;
      width: 140px;
    }
    .btn-pretensiones:hover{
        background-color: #6ed6dc;
        color: #FFFFFF;
    } 
    .btn-cambiar {
      background-color:  #286FBF;
      color: #FFFFFF;
      width: 140px;     
      padding:6px 0px 6px 0px;
    }
    .btn-cambiar:hover{
        background-color:  #5b9ad1;
        color: #FFFFFF;
    }
    .btn-actualizar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-actualizar:hover{
        background-color:  #F6897E;
      color: #FFFFFF;
    }
    .btn-recepcionar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-recepcionar:hover{
        background-color: #F6897E;
      color: #FFFFFF;
    }
    .btn-volver {
      
      color: #66CCCC;
      border: 1px solid #C00
     
      width: 140px;

    }

    .btn-tamano{
      padding: 1rem 1.5rem;
      font-size: 1.5rem;
    }
    `}
      </style>
      <Bitacora
        handleCloseBitacora={handleCloseBitacora}
        showBitacora={showBitacora}
      />

      <Modal show={showCarpeta} onHide={handleCloseCarpeta} size="xl">

        <CarpetaDigitalComponent handleClose={handleCloseCarpeta} 
          idCaso={llaves && llaves['idCaso']}
          idImplicado={llaves && llaves['idImplicado']}
          idOrganizacionCaso={llaves && llaves['idOrgCaso']}
          prototipo={2}            
          />   
      </Modal>

      <PretensionesModal
        handleClosePretensiones={handleClosePretensiones}
        showPretensiones={showPretensiones}

        showImplicados={showImplicados}
        setShowImplicados={setShowImplicados}
        showImplicadosHistorial={showImplicadosHistorial}
        setShowImplicadosHistorial={setShowImplicadosHistorial}
      />

      <PrevisionesModal
        handleClosePrevisiones={handleClosePrevisiones}
        showPrevisiones={showPrevisiones}

        showImplicados={showImplicadosPrev}
        setShowImplicados={setShowImplicadosPrev}
        showImplicadosHistorial={showImplicadosHistorialPrev}
        setShowImplicadosHistorial={setShowImplicadosHistorialPrev}
        modalAction="tab"
        inprocess={inprocess}
        implSeleccionado= {implSeleccionado}
      />

      <Container>
        <Row>
          <Col className='d-flex align-items-end justify-content-end m-2'>
            <Button className='m-2 w-auto' variant='outline-info' onClick={() => history('/area-trabajo-recupero-directo', { state: { queryState } })} >
              {cfg_form38 && cfg_form38.cfg_form38["gestiondefensa-btn-volver"]}
            </Button>
            <Button className='m-2' variant='bitacora' onClick={handleShowBitacora} >
              {cfg_form38 && cfg_form38.cfg_form38["gestiondefensa-btn-bitacora"]}
            </Button>
            <Button className='m-2 ' variant='carpeta' onClick={handleShowCarpeta}>
              {cfg_form38 && cfg_form38.cfg_form38["gestiondefensa-btn-carpeta"]}
            </Button>
            <Button disabled={!implicadoSeleccionado} className='m-2' variant='pretensiones' onClick={handleShowPretensiones}>
              {cfg_form38 && cfg_form38.cfg_form38["gestiondefensa-btn-pretensiones"]}
            </Button>
            <Button disabled={!implicadoSeleccionado} className='m-2' variant='valorizacionpec' name='provisiones' onClick={handleShowProvisiones}>
              {cfg_form38 && cfg_form38.cfg_form38["gestiondefensa-btn-provisiones"]}
            </Button>
            <Button className='m-2' variant='actualizar' type='onSubmit' name='actualizar'>
              {cfg_form38 && cfg_form38.cfg_form38["gestiondefensa-btn-actualiza"]}
            </Button>
          </Col>
        </Row>
      </Container>

      <Modal show={showModalInfo} onHide={() => setShowModalInfo(false)} size='md'>
        <Card>
          <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>Información</Card.Header>
          <Card.Body>Existe Provisiones por visar, debe ser revisada por analista compañía antes de ingresar nuevamente.</Card.Body>

          <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
            <Button className='m-2 w-auto' variant='outline-info' onClick={() => setShowModalInfo(false)}>Cerrar</Button>
          </Card.Footer>
        </Card>
      </Modal>
    </>
  )
}

export default Acciones
